export default 'https://tme.understood.org/assets/collectible.bb8e533d.glb'